<header class="header d-flex align-items-center justify-content-between p-3">
    <div class="logo">
        <img src="assets/icons/mosadad_logo.svg"   />
    </div>
  
    
    <div class="search-container mx-auto">
      <input type="text" class="form-control" placeholder="Search" />
    </div>
  
    
    <div class="d-flex align-items-center">
      
      <div class="dropdown">
        
        <i 
          class="bi bi-globe me-3 icon " 
          id="languageDropdown" 
          data-bs-toggle="dropdown" 
          aria-expanded="false"
          role="button">
        </i>
      
        <!-- Dropdown menu -->
        <ul class="dropdown-menu text-small shadow" aria-labelledby="languageDropdown">
          <li><a class="dropdown-item" href="#">Arabic</a></li>
          <li><a class="dropdown-item" href="#">English</a></li>
        </ul>
      </div>
      <div class="vr custom-divider me-3"></div>
      <i class="bi bi-bell me-4 icon"></i>
      
      
      
      
      <div class="profile d-flex align-items-center">
        <img src="assets/recovery-logo.png" alt="User Profile" class="profile-picture me-2" />
        <span>Danielle Campbell</span>
        
      </div>

      <div class="d-flex flex-column flex-shrink-0 " style="width: 1rem">
        <div class="dropdown ">
          <a
            href="#"
            class="d-flex align-items-center justify-content-center  text-decoration-none dropdown-toggle link-secondary link-opacity-75 link-opacity-50-hover"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            
          </a>
          <ul
            class="dropdown-menu text-small shadow"
          >
            <li><a class="dropdown-item" href="#">Settings</a></li>
            <li><a class="dropdown-item" href="#">Profile</a></li>
            <li><hr class="dropdown-divider" /></li>
            <li><a class="dropdown-item" href="#">Sign out</a></li>
          </ul>
        </div>
      </div>
    </div>
  </header>
  